/* eslint-disable no-nested-ternary */
import Link from 'next/link'
import missingImageIcon from '../../assets/images/missing-image-icon.svg'
import { Icon } from '../Layout/Icon'
import { MegaMenuItem } from './NewMegaMenuHeaderTabs'

type MegaMenuSubHeaderTabProps = {
  menuItems?: MegaMenuItem[]
  onSelect?: (item: MegaMenuItem) => void
  onBack?: () => void
  label?: string
}

export function MegaMenuSubCardGrid(props: MegaMenuSubHeaderTabProps) {
  const { menuItems, onSelect, onBack, label } = props

  if (!menuItems || !menuItems.length) {
    return null
  }

  return (
    <div className='w-full'>
      <div className='flex items-center justify-between mb-5 '>
        {onBack && (
          <button
            onClick={onBack}
            key='back'
            type='button'
            className='flex w-auto items-center justify-start gap-3 text-black hover:text-bright-templi-purple active:text-bright-templi-purple-active lg:min-w-[170px]'
          >
            <Icon name='arrow_back' className='font-bold lg:text-[20px]' />

            <h3>
              <span className='Type-XXL-Medium md:Type-XXL-Medium text-start lg:whitespace-nowrap'>
                Back
              </span>
            </h3>
          </button>
        )}
        <span className='Type-XXL-Regular md:Type-XXL-Regular text-start lg:whitespace-nowrap text-medium-dark-gray'>
          {label}
        </span>
      </div>
      <div className='grid w-full grid-cols-2 gap-[20px]'>
        {menuItems?.map((item) =>
          !item?.isCategory || (item?.isCategory && !item?.children?.length) ? (
            <Link href={item.url ?? ''} type='button'>
              <div
                key={item?.url}
                className='group relative h-full max-h-[200px] min-h-[200px] w-full min-w-[150px] flex-shrink-0 cursor-pointer overflow-hidden rounded-[8px] transition-transform duration-300'
              >
                {/* Background image */}
                {item?.image_url ? (
                  <div
                    className='absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110'
                    style={{ backgroundImage: `url(${item.image_url})` }}
                  />
                ) : (
                  <div
                    className='absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110'
                    style={{ backgroundImage: `url(${missingImageIcon?.src})` }}
                  />
                )}

                {/* Overlay */}
                <div className='absolute inset-0 bg-black/40 transition-colors duration-300 group-hover:bg-black/30' />

                {/* Centered text */}
                <div className='absolute inset-0 flex flex-col items-center justify-center px-2 text-center'>
                  <h3 className='Type-XXL-Medium text-pure-white'>{item.name}</h3>
                </div>
              </div>
            </Link>
          ) : (
            !item.name?.toLowerCase()?.startsWith('view all') && (
              <button
                onClick={() => onSelect?.(item)}
                key={item?.url}
                className='group relative h-full max-h-[200px] min-h-[200px] w-full min-w-[150px] flex-shrink-0 cursor-pointer overflow-hidden rounded-[8px] transition-transform duration-300'
              >
                {/* Background image */}
                {item?.image_url ? (
                  <div
                    className='absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110'
                    style={{ backgroundImage: `url(${item.image_url})` }}
                  />
                ) : (
                  <div
                    className='absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110'
                    style={{ backgroundImage: `url(${missingImageIcon?.src})` }}
                  />
                )}

                {/* Overlay */}
                <div className='absolute inset-0 bg-black/40 transition-colors duration-300 group-hover:bg-black/30' />

                {/* Centered text */}
                <div className='absolute inset-0 flex flex-col items-center justify-center px-2 text-center'>
                  <h3 className='Type-XXL-Medium text-pure-white'>{item.name}</h3>
                </div>
              </button>
            )
          ),
        )}
      </div>
    </div>
  )
}
